import mixpanel from 'mixpanel-browser';

/** Subset of `environment` needed for Mixpanel. */
export interface MixpanelEnvConfig {
  production: boolean;
  mixpanelToken: string;
  mixpanelApiHost: string;
  mixpanelRecordSessionsPercent: number;
}

export function initMixpanelFromEnvironment(env: MixpanelEnvConfig): void {
  const token = env.mixpanelToken?.trim();
  if (!token) {
    return;
  }

  mixpanel.init(token, {
    autocapture: true,
    record_sessions_percent: env.mixpanelRecordSessionsPercent,
    api_host: env.mixpanelApiHost,
    debug: !env.production,
  });
}

export function isMixpanelEnabled(env: MixpanelEnvConfig): boolean {
  return Boolean(env.mixpanelToken?.trim());
}
